import AccountMarketingMaterialProfilePagePrintTemplate from './AccountMarketingMaterialProfilePagePrintTemplate';

export default AccountMarketingMaterialProfilePagePrintTemplate;
